import React from 'react';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import AccountMenu from './AccountMenu';

const TPNShield = `${process.env.PUBLIC_URL}/assets/TPN-Logo-Shield.png`;

// Blends with the page (same background.default), separated by a soft shadow that disappears into the dark rail — badge and rail meet seamlessly.
const Header = styled('header')(({ theme }) => ({
  height: 48,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'stretch',
  background: theme.palette.background.default,
  color: 'rgba(0,0,0,0.87)',
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  position: 'relative',
  zIndex: 40,
}));

const LogoBlock = styled(Link)({
  width: 90,
  flexShrink: 0,
  background: '#3868B9',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const ShieldImg = styled('img')({ height: 36 });

const Spacer = styled('div')({ flex: 1 });

// Right padding matches the 24px content gutter so the avatar lines up with the actions below.
const RightGroup = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 14,
  padding: '0 24px 0 16px',
});

// The icon rail already marks the active destination — the header carries no title; pages render their own heading.
/** Fixed 48px top header: brand shield and account menu. */
export default function HeaderBar() {
  return (
    <Header>
      <LogoBlock to="/" aria-label="TPN+ home">
        <ShieldImg src={TPNShield} alt="TPN+ home" />
      </LogoBlock>

      <Spacer />

      <RightGroup>
        <AccountMenu />
      </RightGroup>
    </Header>
  );
}
